/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Japanese
export default {
  'fabric.atlassianSwitcher.switchTo': '切り替え',
  'fabric.atlassianSwitcher.switchToTooltip': '製品を切り替え...',
  'fabric.atlassianSwitcher.recent': '最近',
  'fabric.atlassianSwitcher.more': 'その他',
  'fabric.atlassianSwitcher.try': '試してみる',
  'fabric.atlassianSwitcher.manageList': 'リストの管理',
  'fabric.atlassianSwitcher.jiraProject': 'Jira プロジェクト',
  'fabric.atlassianSwitcher.confluenceSpace': 'Confluence スペース',
  'fabric.atlassianSwitcher.people': 'ユーザー',
  'fabric.atlassianSwitcher.administration': '管理',
  'fabric.atlassianSwitcher.discoverMore': 'もっと見る',
  'fabric.atlassianSwitcher.errorHeading': 'エラーが発生しました',
  'fabric.atlassianSwitcher.errorText': 'エラーの追跡は常に実行されていますが、更新しても問題が修正されない場合はお気軽にお問い合わせください。',
  'fabric.atlassianSwitcher.errorImageAltText': '人事を尽くして問題の修正に当たっています。',
  'fabric.atlassianSwitcher.expand': '展開する'
};